import React from 'react'
import Box from '@mui/material/Box'
import S3Document from '../../../../../components/images/S3Document'

// Read-only tiles for a record's saved documents. Keys are random UUIDs
// minted at upload, so there is no meaningful file name to list - each tile
// shows a thumbnail (or a type icon) and opens the preview when clicked.
// `small` renders compact tiles for a full-width strip.
const AttachmentTiles = ({ documents, small }) => {
  if (!documents?.length) return null
  return (
    <Box sx={{ mt: 1.5, display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
      {documents.map((key) => (
        <S3Document key={key} item={key} small={small} />
      ))}
    </Box>
  )
}

export default AttachmentTiles
